import { createReducer, on } from '@ngrx/store';
import { LoadingActions } from './loading.actions';

export interface LoadingState {
  show: boolean;
}

const initialState: LoadingState = {
  show: false
};

export const reducer = createReducer(
  initialState,
  on(LoadingActions.loading_start, (state: LoadingState) => ({
    ...state,
    show: true
  })),
  on(LoadingActions.loading_end, (state: LoadingState) => ({
    ...state,
    show: false
  }))
);
